<template>
	<div>
		<!-- Message snackbar -->
		<v-snackbar
			v-model="notifyMessageVisible"
			:timeout="(5000)"
			color="info"
			bottom
			multi-line
		>
			<span v-html="notifyMessage" />
			<template v-slot:action="{ attrs }">
				<v-btn
					v-bind="attrs"
					dark
					text
					@click="notifyMessageVisible = false"
				>
					OK
				</v-btn>
			</template>
		</v-snackbar>

		<!-- Error snackbar -->
		<v-snackbar
			v-model="notifyErrorVisible"
			:timeout="(-1)"
			color="error"
			bottom
			multi-line
		>
			<span v-html="notifyError" />
			<template v-slot:action="{ attrs }">
				<v-btn
					v-bind="attrs"
					dark
					text
					@click="notifyErrorVisible = false"
				>
					OK
				</v-btn>
			</template>
		</v-snackbar>

		<!-- App update notification -->
		<v-snackbar
			v-model="updateAvailable"
			:timeout="(-1)"
			color="info"
			bottom
			multi-line
		>
			Uusi versio saatavilla!
			<template v-slot:action="{ attrs }">
				<v-btn
					v-bind="attrs"
					dark
					text
					@click="refresh"
				>
					Päivitä
				</v-btn>
			</template>
		</v-snackbar>
	</div>
</template>

<script>

import { mapState } from 'vuex'

export default {
	name: 'Notifications',
	props: {
		updateAvailable: {
			type: Boolean,
			default: () => {
				return true
			}
		}
	},
	computed: {
		...mapState([
			'notifyMessage',
			'notifyError',
		]),
		notifyMessageVisible: {
			get () {
				return this.$store.state.notifyMessageVisible
			},
			set (val) {
				this.$store.commit('setNotifyMessageVisible', val)
			},
		},
		notifyErrorVisible: {
			get () {
				return this.$store.state.notifyErrorVisible
			},
			set (val) {
				this.$store.commit('setNotifyErrorVisible', val)
			},
		},
	},
	methods: {
		// Refresh page and force cache bust
		refresh () {
			window.location.reload(true)
		},
	}
}
</script>